import React from 'react'
import VacancyMainBanner from '../templates/Vacancies/vacancyMainBanner'
import VacancySearch from '../templates/Vacancies/vacancySearch'

export const VacancyPage = () => {
  return (
    <div>
        <VacancyMainBanner />
        <VacancySearch />
    </div>
  )
}
